










import Vue from 'vue';
import { ESocialMediaType } from '../../../common/enums/frontpage.enum';
import { IFooterSocialMediaIconsComponent } from '../../../common/interfaces/footer.interface';
import SocialMediaIcon from './SocialMediaIcon.vue';

export default Vue.extend({
  name: `SocialMediaIcons`,
  components: { SocialMediaIcon },
  data(): IFooterSocialMediaIconsComponent {
    return {
      ESocialMediaType,
    };
  },
  computed: {
    groupMode(): string {
      return this.mode.length > 0 ? `social-media--${this.mode}` : ``;
    },
  },
  props: {
    mode: {
      default: ``,
      type: String,
    },
  },
});
